module.exports = __webpack_public_path__ + "static/4-22f492a8e5d1d268cc37475fce4b364d.jpg";